export default __webpack_public_path__ + "static/media/No.4-1.f7c34dcc.jpg";